import { render, staticRenderFns } from "./CDocumentItem.vue?vue&type=template&id=50809ae8&scoped=true&"
import script from "./CDocumentItem.vue?vue&type=script&lang=js&"
export * from "./CDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./CDocumentItem.vue?vue&type=style&index=0&id=50809ae8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50809ae8",
  null
  
)

export default component.exports